import { isRevenue } from '../../services/textService';
import { isCalcParticipatingAdjustmentType } from './adjustmentUtilities';
import { sumIfNumber } from './calculationUtilities';
import {
  ALL_ADJUSTMENTS_KEY,
  EMPTY_VALUE,
  REVENUE_ADJUSTMENTS_KEY,
  TOTALS_KEY,
} from './constants';
import { deconstructAdjustmentKey } from './keyUtilities';
import { selectOrEmpty, selectOrInit } from './selectors';

const FORCE_ACTIVE = true;
const IGNORE_OTHER_CONSIDERATIONS = true;

export const summateToStateKey = (
  targetObject,
  targetKey,
  adjustmentType,
  timePeriod,
  amount,
  isActiveAdjustment,
  ignoreOtherConsiderations = false
) => {
  const target = selectOrInit(targetObject, targetKey);
  const targetTotals = selectOrInit(target, TOTALS_KEY);

  const totalForFinancialPeriod = selectOrEmpty(
    targetTotals,
    timePeriod,
    EMPTY_VALUE
  );

  const isIgnored =
    ignoreOtherConsiderations &&
    !isCalcParticipatingAdjustmentType(adjustmentType);

  const shouldSum = isActiveAdjustment && !isIgnored;

  targetTotals[timePeriod] = shouldSum
    ? sumIfNumber(totalForFinancialPeriod, amount)
    : totalForFinancialPeriod;

  return target;
};

export const summateAdjustments = (adjustmentLines, ignoreActiveFlag = false) =>
  adjustmentLines.reduce((summations, dataPoint) => {
    const { compositeKey, adjustmentAmount } = dataPoint;

    const active = ignoreActiveFlag ? true : dataPoint.active;

    const { adjustmentNumber, shortDescription, adjustmentType, timePeriod } =
      deconstructAdjustmentKey(compositeKey);

    // All Adjustment Totals
    const allAdjustmentsSummations = summateToStateKey(
      summations,
      ALL_ADJUSTMENTS_KEY,
      adjustmentType,
      timePeriod,
      adjustmentAmount,
      active,
      IGNORE_OTHER_CONSIDERATIONS
    );

    // Adjustment Type Totals
    const adjustmentTypeSummations = summateToStateKey(
      allAdjustmentsSummations,
      adjustmentType,
      adjustmentType,
      timePeriod,
      adjustmentAmount,
      active
    );

    // Individual Adjustment Totals
    const adjName = `${adjustmentNumber} ${shortDescription}`;
    summateToStateKey(
      adjustmentTypeSummations,
      adjName,
      adjustmentType,
      timePeriod,
      adjustmentAmount,
      FORCE_ACTIVE
    );

    return summations;
  }, {});

const adjustsRevenue = (adjustment) => {
  const { adjustmentCategory } = deconstructAdjustmentKey(
    adjustment.compositeKey
  );

  return isRevenue(adjustmentCategory);
};

export const summateRevenueAdjustments = (
  adjustmentLines,
  ignoreActiveFlag = false
) =>
  adjustmentLines.filter(adjustsRevenue).reduce((summation, dataPoint) => {
    const { compositeKey, adjustmentAmount } = dataPoint;
    const active = ignoreActiveFlag ? true : dataPoint.active;
    const { adjustmentType, timePeriod } =
      deconstructAdjustmentKey(compositeKey);

    summateToStateKey(
      summation,
      REVENUE_ADJUSTMENTS_KEY,
      adjustmentType,
      timePeriod,
      adjustmentAmount,
      active,
      IGNORE_OTHER_CONSIDERATIONS
    );

    return summation;
  }, {});
